<template>
  <article class="view-content view-layout">
    <section>
      <NavBar v-if="navbar === 'F'"/>
      <NavBar v-if="navbar === 'L'" light />
    </section>
    <section
      class="content"
      :class="{'content--scrollable': footer === 'NS'}">
      <section
        class="content__viewport"
        :class="{'content__viewport--scrollable': footer !== 'NS'}">
        <transition name="router" mode="out-in">
          <router-view/>
        </transition>
      </section>
      <section class="content__footer">
        <Footer v-if="footer === 'NS'" />
      </section>
    </section>
    <section>
      <Footer v-if="footer === 'S'" />
    </section>
  </article>
</template>

<script>
import Footer from '@components/Footer.vue'
import NavBar from '@components/NavBar.vue'
export default {
  name: 'LayoutTemplate',
  components: {
    Footer, NavBar
  },
  props: {
    footer: String,
    navbar: String
  }
}
</script>

<style lang="scss" scoped>
  .view-layout {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    .content {
      flex: 1 1 0;
      display: flex;
      flex-direction: column;
      &--scrollable {
        overflow-y: auto;
      }
      &__viewport {
        flex: 1 1 0;
        &--scrollable {
          overflow-y: auto;
        }
      }
    }
  }
</style>
